import React from "react";
import { Route } from "react-router-dom";
import ClientSignIn from "../components/client_signin";
import ClientSignUp from "../components/client_signup";
import ClientForgotPassword from "../components/client_forgot_password";
import ClientResetPassword from "../components/client_reset_password";

const SignInRoutes = () => {
  return (
    <>
      <Route path="/signin" element={<ClientSignIn />} /> 
      <Route path="/signup" element={<ClientSignUp />} /> 
      <Route path="/forgot-password" element={<ClientForgotPassword />} /> 
      <Route path="/reset-password/:token" element={<ClientResetPassword />} /> 
    </>
  );
};

export default SignInRoutes;
